module.exports = __webpack_public_path__ + "static/media/forwards.018d5682.svg";